import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import GlobalBottomBanner from "./pages/home/components/GlobalBottomBanner";
import GlobalCasinoOverlay from "./pages/home/components/GlobalCasinoOverlay";
import ScrollToTop from "./components/common/ScrollToTop";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />

      <AppRoutes />
      <GlobalBottomBanner />
      <GlobalCasinoOverlay />
    </BrowserRouter>
  );
}

export default App;
